import React, { useCallback, useContext, useEffect, useRef, useState } from "react";

import Utils from "../../../../Common/Utils";
import Label from "../../../Common/components/Label";
import { listAttributeValuesByAttributeID } from "api/Attributes";
import { AttributeContext } from "../AttributeContext";
import {toast} from 'react-toastify'
import ViewMoreButton from "Components/Common/components/ViewMoreButton";
import CustomSearchBar from '../../../GMS/Products/components/CustomSearchBar'

const AttributeValuesView = () => {
  const { editingItem, attributeLoading, setAttributeLoading } = useContext(AttributeContext);

  const [loading, setLoading] = useState({
    status: "",
    message: "",
  });
  const [attValues, setAttValues] = useState(null);
  const [attValuesCount, setAttValuesCount] =  useState(0)
  const [collapse, setCollapse] = useState(false);
  const [search, setSearch] = useState("")
  const attrId = useRef(null)

  function handle_collapse() {
    setCollapse(!collapse);
  }

  const fetchCategoriesData = useCallback((search, skip, reset) => {
    const limit = skip !== undefined ? 10 + skip : 10;
    if(reset) setAttValues(null)
    setAttributeLoading(true)
    attrId.current = editingItem.id
    setLoading({status: "Loading", message: "Loading..."})
    listAttributeValuesByAttributeID(editingItem.id, limit, skip, search)
    .then(({count, attribute_values}) => {
      setAttValues((prev) => {
        return (prev || !reset) ? [...prev, ...attribute_values] : attribute_values
      })
      setAttValuesCount(count)
      setLoading({
        status: "Success",
        message: ""
      })
    })
    .catch(err => {
      toast.error(err.message)
      setLoading({
        status: "Error",
        message: err.message
      })
    }).finally(()=>setAttributeLoading(false))
  }, [])

  useEffect(() => {
    fetchCategoriesData(search, undefined, true)
  }, [search])

  useEffect(() => {
    setAttValues([])
    setAttValuesCount(0)
  }, [editingItem.id, search])

  useEffect(() => {
    if(!collapse || attrId.current === editingItem.id) return 
    setAttValues([])
    setAttValues(0)
    fetchCategoriesData()
  }, [collapse])


  return (
    <>
      <div className="accordion" id="accordionFlushAttv">
        <div className="accordion-item border-0">
          <div
            className="accordion-button bg-white collapsed"
            onClick={() => handle_collapse()}
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#flush-collapseAttv"
            aria-controls="flush-collapseAttv"
            style={Utils.borderStyle()}
            //   style={{ border: "1px solid #d6d8d9" }}
          >
            <Label message="Attribute Values" />
          </div>

          <div
            id="flush-collapseAttv"
            className="accordion-collapse collapse"
            aria-labelledby="flush-headingAttv"
            data-bs-parent="#accordionFlushAttv"
          >
            <div className="accordion-body p-0" style={{ minHeight: "30px", border: "1px solid #d6d8d9" }}>
              <div className="tw-flex tw-justify-end tw-pt-2 tw-px-2">
                <div className="tw-w-min">
                  <CustomSearchBar 
                    placeholder="Search Attribute Values"
                    handleSearchChange = {setSearch}
                    value={search}
                    disabled={attributeLoading}
                    delay={1000}
                  />
                </div>
              </div>

              {loading.status === "Loading" && (
                <div className="alert alert-primary bg-white small p-2" role="alert">
                  <span className="fas fa-circle-notch fa-spin" />
                  &nbsp;
                  <strong>{loading.message}</strong>
                </div>
              )}

              { 
                loading.status === "Error" && (
                  <div
                    className="alert alert-danger small p-2"
                    role="alert"
                  >
                    <strong>{loading.message}</strong>
                  </div>
              )}

              {loading.status === "Success" && attValues && (
                <>
                  <div className="p-3" style={{  }}>
                    {attValues && attValues.length > 0 ? (
                      <div className="tw-flex tw-flex-wrap tw-items-center">
                        {attValues.map((item, index) => {
                          return (
                            <div className="d-inline" key={index}>
                              <span
                                className="badge"
                                style={{
                                  fontSize: "0.75rem",
                                  backgroundColor: "#F2F2F2",
                                  marginBottom: "10px",
                                  color: "#5c5f62",
                                  fontFamily: "Noto Sans",
                                  fontWeight: "401",
                                  padding: "6px",
                                }}
                              >
                                {item.value}
                              </span>
                              &nbsp;&nbsp;
                            </div>
                          );
                        })}

                        <ViewMoreButton
                          condition = {attValues.length < attValuesCount}
                          state = {attValues.length >= attValuesCount}
                          handleClick = {() => fetchCategoriesData(search, attValues.length)}
                        />
                        
                      </div>
                    ) : (
                      <div
                        className="alert alert-dark bg-white small p-2"
                        role="alert"
                      >
                        <strong>Attribute Values Not Found</strong>
                      </div>
                    )}
                  </div>
                 
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AttributeValuesView;

function EditSnngleValue({
  item,
  changeCursorToPointer,
  handleEdit,
  cancelEdit,
  index,
  findDuplicates,
  setLoading,
}) {
  const [value, setValue] = useState(item.value);

  return (
    <span className="badge badge-pill  text-dark border border-dark border-1 bg-light">
      {/*{item.value} &nbsp;*/}
      <input
        type="text"
        value={value || ""}
        onChange={(e) => {
          setValue(e.target.value);
        }}
        style={{ width: "100px" }}
        onKeyDown={(e) => {
          if (value !== item.value && value !== "") {
            if (e.key === "Enter") {
              if (!findDuplicates(value)) {
                handleEdit(
                  e,
                  {
                    ...item,
                    value: value,
                  },
                  index,
                  value
                );

                setLoading({
                  status: "",
                  message: "",
                });
              } else {
                setLoading({
                  status: "Error",
                  message:
                    "Value with the same name already existing in the list.",
                });

                setTimeout(() => {
                  setLoading({
                    status: "",
                    message: "",
                  });
                }, 5000);
              }
            }
          }
        }}
      />
      &nbsp;{" "}
      <i
        className="fas fa-times"
        onMouseOver={changeCursorToPointer}
        onClick={() => cancelEdit(item, index)}
      />
    </span>
  );
}

const EditAttValues = ({
  attValues,
  setFinalAttValues,
  reset,
  loading,
  setLoading,
}) => {
  const [attributeValues, setAttributeValues] = useState(null);
  const [textField, setTextfield] = useState("");
  const [deletedValues, setDeletedValues] = useState([]);
  const [editedValues, setEditedValues] = useState([]);
  const [newValues, setNewValues] = useState([]);
  const [addedEditedDeletedValues, setAddededitedDeletedValues] =
    useState(null);

  useEffect(() => {
    setTextfield("");
    setDeletedValues([]);
    setNewValues([]);
    setEditedValues([]);
    setAddededitedDeletedValues(null);
    setFinalAttValues([]);
    let arr = [];
    attValues.map((item, index) => {
      arr.push({ ...item, toggle: false });
    });
    setAttributeValues(arr);
  }, [attValues, reset]);

  useEffect(() => {
    if (attributeValues && attributeValues.length > 0) {
      let finalValuesList = [];
      let attrValues = [...attributeValues];
      if (newValues && newValues.length > 0) {
        attrValues = [...attrValues, ...newValues];
        finalValuesList.push(...newValues);
      }
      if (editedValues && editedValues.length > 0) {
        attrValues = [...attrValues, ...editedValues];
        finalValuesList.push(...editedValues);
      }
      if (deletedValues && deletedValues.length > 0) {
        attrValues = [...attrValues, ...deletedValues];
        finalValuesList.push(...deletedValues);
      }
      setAddededitedDeletedValues(attrValues);
      setFinalAttValues(finalValuesList);
    }
  }, [attributeValues, editedValues, deletedValues, newValues]);

  function isEmpty(str) {
    function myTrim(x) {
      return x.replace(/^\s+|\s+$/gm, "");
    }

    return myTrim(str).length === 0;
  }

  function handleDelete(item, index) {
    let obj = {
      ...item,
      edited: false,
      toggle: false,
      deleted: true,
      changed: true,
    };
    let arr = [...attributeValues];
    arr.splice(index, 1, obj);
    if (item.id !== null) {
      // check and delete deletedvalue in editedvalues list
      let editingIndex = editedValues.findIndex(
        (value) => value.id === item.id
      );
      if (editingIndex >= 0) {
        let arr = [...editedValues];
        arr.splice(editingIndex, 1);
        setEditedValues(arr);
      }

      setDeletedValues((prevState) => [...prevState, obj]);
    }

    setAttributeValues(arr);
  }

  function handleEdit(e, item, index) {
    let editedVls = [...editedValues];
    let editedValIndex = editedVls.findIndex((val) => val.id === item.id);

    let obj = {
      ...item,
      value: e.target.value,
      edited: true,
      toggle: false,
      deleted: false,
      changed: true,
    };
    let arr = [...attributeValues];
    arr.splice(index, 1, obj);
    if (item.id !== null) {
      if (editedValIndex >= 0) {
        editedVls.splice(editedValIndex, 1, obj);
        setEditedValues(editedVls);
      } else {
        setEditedValues((prevState) => [...prevState, obj]);
      }
    }
    setAttributeValues(arr);
  }

  function cancelEdit(item, index) {
    let arr = [...attributeValues];
    let obj = { ...attributeValues[index], toggle: false };
    arr.splice(index, 1, obj);
    setAttributeValues(arr);
  }

  function cancelAddEditDelete(item) {
    let initialAttValues = [...attValues];
    let initialItem = initialAttValues.find((i) => i.id === item.id);
    let attrValues = [...attributeValues];
    let ind = attributeValues.findIndex((i) => i.id === item.id);
    if (item.edited) {
      let edited = [...editedValues];
      let index = edited.findIndex((i) => i.id === item.id);
      edited.splice(index, 1);
      attrValues.splice(ind, 1, { ...initialItem, toggle: false });
      setEditedValues(edited);
      setAttributeValues(attrValues);
    } else if (item.deleted) {
      let deleted = [...deletedValues];
      let index = deleted.findIndex((i) => i.id === item.id);
      deleted.splice(index, 1);
      attrValues.splice(ind, 1, { ...initialItem, toggle: false });
      setDeletedValues(deleted);
      setAttributeValues(attrValues);
    } else if (item.id === null) {
      let newValuesList = [...newValues];
      let index = newValuesList.findIndex((i) => i.value === item.value);
      let ind = attributeValues.findIndex((i) => i.value === item.value);
      newValuesList.splice(index, 1);
      attrValues.splice(ind, 1);
      setNewValues(newValuesList);
      setAttributeValues(attrValues);
    }
  }

  function findDuplicates(value) {
    if (addedEditedDeletedValues && addedEditedDeletedValues.length > 0) {
      let index = addedEditedDeletedValues.findIndex((i) => i.value === value);

      return index >= 0;
    }
  }

  function handleCheckBox(checkStatus, id) {
    let attValuesCopy = [...attValues];
    let attValuesCopyIndex = attValuesCopy.findIndex((att) => att.id === id);
    let attValuesCopyItem = attValuesCopy[attValuesCopyIndex];

    let arr = [...attributeValues];
    let attributeValuesIndex = arr.findIndex((att) => att.id === id);
    let item = arr[attributeValuesIndex];
    if (attValuesCopy[attValuesCopyIndex].active === checkStatus) {
      if (attributeValuesIndex >= 0) {
        let editedValuesArr = [...editedValues];
        let index = editedValuesArr.findIndex((att) => att.id === id);
        let obj = {
          ...item,
          edited: false,
          toggle: false,
          deleted: false,
          changed: false,
          active: checkStatus,
        };
        if (attValuesCopyItem.item === obj.item) {
          editedValuesArr.splice(index, 1);
          setEditedValues([...editedValuesArr]);
        } else {
          editedValuesArr.splice(index, 1, { ...obj, active: checkStatus });
          setEditedValues([...editedValuesArr]);
        }

        arr.splice(attributeValuesIndex, 1, obj);
        setAttributeValues(arr);
      }
    } else {
      let obj = {
        ...item,
        edited: true,
        toggle: false,
        deleted: false,
        changed: true,
        active: checkStatus,
      };
      arr.splice(attributeValuesIndex, 1, obj);
      if (item.id !== null) {
        setEditedValues((prevState) => [...prevState, obj]);
      }
      setAttributeValues(arr);
    }
  }

  return (
    <div>
      <div>
        <input
          className="form-control"
          placeholder={"Type values and press 'ENTER' button to add"}
          style={{
            fontWeight: "600",
            fontSize: "0.9rem",
          }}
          value={textField}
          onChange={(e) => {
            setTextfield(e.target.value);
          }}
          onKeyPress={(e) => {
            let newValue = e.target.value;
            if (e.key === "Enter") {
              e.preventDefault();
              if (!isEmpty(newValue)) {
                let splitValue = newValue
                  .split(",")
                  .filter((e, i, a) => a.indexOf(e) === i);
                splitValue.map((item) => {
                  let duplicates = findDuplicates(item);
                  if (!duplicates) {
                    let obj = {
                      id: null,
                      value: item,
                      active: true,
                      edited: false,
                      deleted: false,
                      toggle: false,
                      changed: true,
                    };
                    setAttributeValues((prev) => [...prev, obj]);
                    setNewValues((prev) => [...prev, obj]);
                    setTextfield("");
                  } else {
                    setLoading({
                      status: "Error",
                      message:
                        "Duplicate values cannot be added and are removed.",
                    });
                    setTextfield("");
                    setTimeout(() => {
                      setLoading({
                        status: "",
                        message: "",
                      });
                    }, 5000);
                  }
                });
              }
            }
          }}
          id="AttributeValue"
          autoComplete="off"
        />
        <div className="mt-3">
          <LoadingSuccessErrorAlert loading={loading} />
        </div>
        <div style={{ minHeight: "50px" }} className="p-3">
          {/*{loading.status === "Error" && (*/}
          {/*    <div className="alert alert-danger small p-2" role="alert">*/}
          {/*        <span className="fas fa-exclamation-triangle"/>*/}
          {/*        &nbsp;*/}
          {/*        <strong>{loading.message}</strong>*/}
          {/*        /!*<i className="fas fa-times float-end"  onMouseOver={changeCursorToPointer}*!/*/}
          {/*        /!*   onClick={handleCloseAlert} />*!/*/}
          {/*    </div>*/}
          {/*)}*/}
          <div
            style={{ minHeight: "50px" }}
            className="d-flex flex-wrap flex-row align-items-start  w-100 pb-3 gap-2"
          >
            {attributeValues &&
              attributeValues.length > 0 &&
              attributeValues.map((item, index) => {
                function getStyledColor() {
                  if (item.id === null) {
                    return "bg-success";
                  } else if (item.edited === true) {
                    return "bg-primary";
                  } else if (item.deleted === true) {
                    return "bg-danger";
                  } else {
                    return "bg-light text-dark ";
                  }
                }

                return item.toggle === false ? (
                  <div
                    className={
                      "d-flex justify-content-center  border border-1 border-dark p-1"
                    }
                    key={index}
                    onMouseOver={changeCursorToPointer}
                    onDoubleClick={(e) => {
                      if (item.id !== null && !item.deleted) {
                        let arr = [...attributeValues];
                        arr.splice(index, 1, { ...arr[index], toggle: true });
                        setAttributeValues(arr);
                      }
                    }}
                  >
                    <div className="form-check form-switch">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="flexSwitchCheckChecked"
                        style={{ color: "black", fontSize: ".8rem" }}
                        checked={item.active}
                        onChange={(e) =>
                          handleCheckBox(e.target.checked, item.id)
                        }
                      />
                    </div>

                    <span
                      className={`badge badge-pill align-middle pt-2 ${getStyledColor()} `}
                    >
                      <Label
                        message={item.value}
                        fontSize=".7rem"
                        color={`${
                          item.id !== null &&
                          item.edited !== true &&
                          item.deleted !== true
                            ? "black"
                            : "white"
                        }`}
                      />
                      &emsp;{" "}
                      <i
                        className="fas fa-times"
                        onMouseOver={changeCursorToPointer}
                        onClick={() => {
                          if (
                            item.edited === true ||
                            item.deleted === true ||
                            item.id === null
                          ) {
                            cancelAddEditDelete(item, index);
                          } else {
                            handleDelete(item, index);
                          }
                        }}
                      />
                    </span>
                  </div>
                ) : (
                  <EditSnngleValue
                    item={item}
                    cancelEdit={cancelEdit}
                    index={index}
                    handleEdit={handleEdit}
                    setLoading={setLoading}
                    findDuplicates={findDuplicates}
                    changeCursorToPointer={changeCursorToPointer}
                  />
                );
              })}
          </div>
          <div className="mt-3">
            <i className="fas fa-circle" style={{ color: "#6c757d" }} />
            <span>
              {" "}
              <Label
                message=" Existing Values in system"
                fontSize={0.8}
                color="#909090"
                fontWeight="600"
              />
            </span>{" "}
            &emsp;
            <i className="fas fa-circle" style={{ color: "#198754" }} />
            <span>
              {" "}
              <Label
                message=" Newly added Values"
                fontSize={0.8}
                color="#909090"
                fontWeight="600"
              />
            </span>{" "}
            &emsp;
            <i className="fas fa-circle" style={{ color: "#0d6efd" }} />
            <span>
              {" "}
              <Label
                message=" Edited Values"
                fontSize={0.8}
                color="#909090"
                fontWeight="600"
              />
            </span>{" "}
            &emsp;
            <i className="fas fa-circle" style={{ color: "#dc3545" }} />
            <span>
              {" "}
              <Label
                message=" Deleted Values"
                fontSize={0.8}
                color="#909090"
                fontWeight="600"
              />
            </span>{" "}
            &emsp;
            <i className="fas fa-info" /> &nbsp;
            <span>
              {" "}
              <Label
                message="Double Click on chips to edit values"
                fontSize={0.8}
                color="#909090"
                fontWeight="600"
              />
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
function changeCursorToPointer(e) {
  e.target.style.cursor = "pointer";
}

function LoadingSuccessErrorAlert({ loading }) {
  return (
    <>
      {loading.status === "Saving" && (
        <div className="alert alert-primary bg-white small p-2" role="alert">
          <span className="fas fa-circle-notch fa-spin" />
          &nbsp;
          <strong>{loading.message}</strong>
        </div>
      )}
      {loading.status === "Loading" && (
        <div className="aalert alert-primary bg-white small p-2" role="alert">
          <span className="fas fa-circle-notch fa-spin" />
          &nbsp;
          <strong>{loading.message}</strong>
        </div>
      )}
      {loading.status === "Error" && (
        <>
          <div className="alert alert-danger bg-white small p-2" role="alert">
            <span className="fas fa-exclamation-triangle" />
            &nbsp;
            <strong>{loading.message}</strong>
            {/*<i className="fas fa-times float-end"  onMouseOver={changeCursorToPointer}*/}
            {/*   onClick={handleCloseAlert} />*/}
          </div>
          {loading.message2 && (
            <div
              className="alert alert-primary bg-white small p-2"
              role="alert"
            >
              <span className="far fa-check-circle" />
              &nbsp;
              <strong>{loading.message2}</strong>
            </div>
          )}
        </>
      )}
      {loading.status === "Success" && loading.message !== undefined && (
        <div className="alert alert-primary bg-white small p-2" role="alert">
          <span className="far fa-check-circle" />
          &nbsp;
          <strong>{loading.message}</strong>
        </div>
      )}
    </>
  );
}